/**
 * Auth Context - Mock Implementation
 * Replace this with your real authentication system
 */

import { createContext, type ReactNode } from 'react';
import type { User } from '@/types/roles';

// Mock user - change the role here to test different views
const mockUser: User = {
  id: 'user-001',
  name: 'Sarah Johnson',
  email: 'sarah.johnson@company.com',
  role: 'manager',  // Changed to manager to see Collections Dashboard
  teamId: 'team-001',
};

console.log('[AuthContext] Initializing with user:', mockUser);

interface AuthContextType {
  user: User;
  isAuthenticated: boolean;
  login: (email: string, password: string) => Promise<void>;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

interface AuthProviderProps {
  children: ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
  const value: AuthContextType = {
    user: mockUser,
    isAuthenticated: true,
    login: async () => {
      // Mock login
      console.log('Mock login called');
    },
    logout: () => {
      // Mock logout
      console.log('Mock logout called');
    },
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
